import { render, staticRenderFns } from "./PortfolioHeader.vue?vue&type=template&id=07ed5b30&"
import script from "./PortfolioHeader.vue?vue&type=script&lang=js&"
export * from "./PortfolioHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports